(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-arena/assets/javascripts/start.js') >= 0) return;  svs.modules.push('/modules/racing-arena/assets/javascripts/start.js');

'use strict';

const {
  useRef,
  useEffect,
  useState
} = React;
const RacecardPicker = svs.racing_arena.RacecardPicker;
const RaceSummaryList = svs.racing_arena.RaceSummaryList;
const useRaceSummaries = svs.racing.raceService.useRaceSummaries;
const racePickerModes = svs.racing.common.constants.racePickerModes;
const ClosedView = svs.racing.closedView.ClosedView;
const override = svs.racing_arena.data.closedView;
const Start = () => {
  const {
    showRacePicker,
    racecardDate,
    racePickerModeHot
  } = svs.racing_arena.data;
  const urlParams = new URLSearchParams(window.location.search);
  const modeFromUrl = urlParams.get('mode');
  const currentPickerMode = modeFromUrl ? modeFromUrl : racePickerModes.TIMELINE;
  const [racecard, setRacecard] = useState({
    currentRacecard: racePickerModeHot ? svs.racing_arena.data.racecardHot : svs.racing_arena.data.racecard,
    currentRacePickerMode: racePickerModeHot ? racePickerModes.HOT : currentPickerMode
  });
  const raceSummaries = useRaceSummaries(racecard.currentRacecard, racecard.currentRacePickerMode === racePickerModes.HOT);
  const scrollToPicker = ref => {
    window.scrollTo({
      top: ref.current.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  };
  const scrollToRef = useRef(null);
  useEffect(() => {
    if (raceSummaries && window.location.href.indexOf('resultat') > -1) {
      scrollToPicker(scrollToRef);
    }
  }, [raceSummaries]);
  return React.createElement("div", {
    className: "arena-section",
    ref: scrollToRef
  }, React.createElement(ClosedView, {
    header: override === null || override === void 0 ? void 0 : override.header,
    isEnabled: override === null || override === void 0 ? void 0 : override.isEnabled,
    text: override === null || override === void 0 ? void 0 : override.text
  }), React.createElement("div", {
    className: "arena-max-width"
  }, showRacePicker ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "picker-header picker-header-start"
  }, React.createElement("div", null, "V\xE4lj lopp"), React.createElement("div", {
    className: "sub-header"
  }, "Startlistor och resultat")), React.createElement(RacecardPicker, {
    racecard: racecard.currentRacecard,
    racePickerMode: racecard.currentRacePickerMode,
    setDate: racecardDate && new Date(racecardDate),
    setRacecard: setRacecard
  }), React.createElement("div", null, React.createElement(RaceSummaryList, {
    emptyDataViewLabel: racecard.currentRacePickerMode === racePickerModes.HOT ? 'Just nu finns det inga spelbara lopp' : 'Det finns inga spelbara lopp för det här datumet',
    racecard: racecard.currentRacecard,
    racePickerMode: racecard.currentRacePickerMode,
    raceSummaries: raceSummaries
  }))) : null));
};
ReactDOM.render(React.createElement(Start, null), document.getElementById('start-container'));


 })(window);